export const topBarHeight = 64
export const sideNavWidth = 260
export const navbarHeight = 60
export const sidenavCompactWidth = 80
export const containedLayoutWidth = 1200

const x = 300
const fontSize = 10
export const settlementCoordinates = {
    createdDate: {
        x: 510,
        y: 734,
        size: 8,
    },
    createdHour: {
        x: 510,
        y: 725,
        size: 8,
    },
    idPestamo: {
        x: x,
        y: 655,
        size: fontSize,
    },
    cliente: {
        x: 250,
        y: 630,
        size: fontSize,
    },
    convenio: {
        x: x,
        y: 606,
        size: fontSize,
    },
    montoCredito: {
        x: x,
        y: 566,
        size: fontSize,
    },
    plazo: {
        x: x,
        y: 546,
        size: fontSize,
    },
    pagos: {
        x: x,
        y: 526,
        size: fontSize,
    },
    descuento: {
        x: x,
        y: 506,
        size: fontSize,
    },
    transito: {
        x: x,
        y: 486,
        size: fontSize
    },
    saldoFinal: {
        x: x,
        y: 463,
        size: fontSize,
    },
    vigencia: {
        x: x,
        y: 442,
        size: fontSize,
    },
    fechaDescuento: {
        x: x,
        y: 422,
        size: fontSize,
    },
    titularPago: {
        x: x,
        y: 369,
        size: fontSize,
    },
    bancoPago: {
        x: x,
        y: 350,
        size: fontSize,
    },
    cuentaPago: {
        x: x,
        y: 331,
        size: fontSize,
    },
    clabePago: {
        x: x,
        y: 312,
        size: fontSize,
    },
    referencia: {
        x: x,
        y: 293,
        size: fontSize,
    },
    montoTotal: {
        x: x,
        y: 274,
        size: fontSize,
    }
}

export const settlementCreditCoordinatesBaracaf = {
    fecha: {
        x: 228,
        y: 597,
        size: 10,
    },
    clienteA: {
        x: 117,
        y: 533,
        size: 10,
    },
    creditoA: {
        x: 136,
        y: 515,
        size: 10,
    },
    fechaApertura: {
        x: 310,
        y: 515,
        size: 10,
    },
    clienteB: {
        x: 86,
        y: 481,
        size: 10,
    },
    fechaDeposito: {
        x: 398,
        y: 430,
        size: 10,
    },
    clienteC: {
        x: 135,
        y: 395,
        size: 10,
    },
    creditoB: {
        x: 240,
        y: 378,
        size: 10,
    },
    clienteD: {
        x: 86,
        y: 343,
        size: 10,
    }
}

export const settlementCreditCoordinatesRapido = {
    fecha: {
        x: 230,
        y: 597,
        size: 10,
    },
    clienteA: {
        x: 117,
        y: 533,
        size: 10,
    },
    creditoA: {
        x: 96,
        y: 517,
        size: 10,
    },
    fechaApertura: {
        x: 273,
        y: 517,
        size: 10,
    },
    clienteB: {
        x: 86,
        y: 482,
        size: 10,
    },
    fechaDeposito: {
        x: 86,
        y: 413,
        size: 10,
    },
    clienteC: {
        x: 86,
        y: 378,
        size: 10,
    },
    creditoB: {
        x: 133,
        y: 362,
        size: 10,
    },
    clienteD: {
        x: 228,
        y: 345,
        size: 10,
    }
}